import { PrizeUrlProps } from "./types";
import styles from "./winners.module.css";

const PrizeUrl = ({ competitionType, competitionPictureTitle, prize }: PrizeUrlProps) => {
  const getParaText = () => {
    if (competitionType === "SuperDrivesWinner") {
      return competitionPictureTitle;
    }
    return prize;
  };

  return <p className={`uppercase ${styles.prizeUrlText}`}>{getParaText()}</p>;
};

export default PrizeUrl;
